import type { ReactNode } from 'react';

import { AhoyLogo } from '@/lib/foundations/logo/ahoy-logo';

interface PortfolioStandaloneLayoutProps {
  children: ReactNode;
}

/**
 * Minimal branded shell for the standalone `/portfolio` route — the fallback
 * for portfolio admins with no org membership of their own, who cannot use the
 * org-scoped app shell (`/:orgId/portfolio` inside DashboardLayout). Provides
 * the Ahoy header so the page is recognizably part of the product rather than
 * a bare white canvas.
 */
export function PortfolioStandaloneLayout({
  children,
}: PortfolioStandaloneLayoutProps) {
  return (
    <div className='min-h-dvh gradient-bg'>
      <header className='flex items-center border-b border-[var(--color-border-secondary)] bg-[var(--color-bg-primary)] px-4 py-3 sm:px-6'>
        <AhoyLogo href='/portfolio' size='sm' />
      </header>
      {children}
    </div>
  );
}
